import React from 'react'
import FlashNotification from '../shared/flashNotification'
import Loading from '../shared/loading'
import { useCatalogue } from './CatalogueProvider'
import CatalogueHeader from './CatalogueHeader'
import CategorySidebar from './CategorySidebar'
import RootCategoryGrid from './RootCategoryGrid'
import CatalogueTable from './category_table/CatalogueTable'
import { EditProductForm, NewProductForm } from './item_form/ProductForms'
import { EditCategoryForm, NewCategoryForm } from './item_form/CategoryForms'
import ProductDetailsDialog from './dialogs/ProductDetailsDialog'
import DeleteCatalogueItemDialog from './dialogs/DeleteCatalogueItemDialog'

const CatalogueWorkspace = () => {
  const { state } = useCatalogue()
  const { panel, panelKey, categoryId, treeLoading } = state

  switch (panel.kind) {
    case 'new':
      return panel.type === 'product' ? <NewProductForm key={panelKey} /> : <NewCategoryForm key={panelKey} />
    case 'edit':
      if (treeLoading) return null
      return panel.item.class_name === 'Product' ? (
        <EditProductForm key={panelKey} product={panel.item} />
      ) : (
        <EditCategoryForm key={panelKey} category={panel.item} />
      )
    case 'browse':
      return categoryId === null ? <RootCategoryGrid /> : <CatalogueTable />
  }
}

const CatalogueLayout = () => {
  const { state, actions } = useCatalogue()
  const { notice, treeLoading } = state

  return (
    <div>
      {notice ? (
        <FlashNotification key={notice.id} type={notice.kind} message={notice.message} onClose={actions.dismissNotice} />
      ) : null}
      <CatalogueHeader />
      <div className="container">
        <div className="row">
          <div className="col-2 p-0">
            <CategorySidebar />
          </div>
          <div className="col-10 p-0 product-cards">
            {treeLoading ? <Loading /> : null}
            <CatalogueWorkspace />
          </div>
        </div>
      </div>
      <DeleteCatalogueItemDialog />
      <ProductDetailsDialog />
    </div>
  )
}

export default CatalogueLayout
